export const MachineModesOrder = [
    'idle',
    'maintenance',
    'sterilization',
    'cleaning',
    'downtime',
    'production downtime',
    'uptime',
    'production uptime',
    'production'
  ];